// In your dispatcher/routes.ts
import { RouteObject } from "react-router-dom";
import WorkOrderSettings from "./components/workorder/workorder";
import FieldForceSettings from "./components/fieldForce/landing/FieldForceSettings";

export interface SettingsSetupRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: SettingsSetupRoute[];
}

export const settingsSetupRoutes: SettingsSetupRoute[] = [
  {
    path: "/service-orders/settings/workorder",
    element: <WorkOrderSettings />,
  },
  {
    path: "/service-orders/settings/fieldforce",
    element: <FieldForceSettings />,
  },
];
